import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TipoVariableService} from './tipoVariable.service';
import {TipoVariable} from './tipoVariable';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'tipoVariable',
    template: require('../../app/tipoVariable/tipoVariable.component.html'),
    styles: [require('../../app/tipoVariable/tipoVariable.component.css')]
})
export class TipoVariableComponent implements OnInit {
    tipoVariable: TipoVariable;
    idSeleccionado;
    active: any;
    deshabilitar: boolean;
    permisos: any;

    constructor(private tipoVariableService: TipoVariableService,
                private permisoService: PermisoService,
                private loginService: LoginService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("tipoVariable").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        })

        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/tipoVariable/tipoVariableTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        })
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        //Inicializar
        this.tipoVariable = new TipoVariable();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;

    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.tipoVariable = new TipoVariable();
        this.deshabilitar = false;
        $("#modalTipoVariable").modal("show");
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    modificar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoVariable
                this.tipoVariableService
                    .getTipoVariable(this.idSeleccionado)
                    .subscribe(tipoVariable => {
                        this.tipoVariable = tipoVariable;
                    });
                this.deshabilitar = false;
                $("#modalTipoVariable").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoVariable
                this.tipoVariableService
                    .getTipoVariable(this.idSeleccionado)
                    .subscribe(tipoVariable => {
                        this.tipoVariableService.delete(tipoVariable).subscribe(() => $("#grid-data").bootgrid("reload"));

                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoVariable
                this.tipoVariableService
                    .getTipoVariable(this.idSeleccionado)
                    .subscribe(tipoVariable => {
                        this.tipoVariable = tipoVariable;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                $("#modalTipoVariable").modal("show");

            }
        }
    }

    save() {

        this.tipoVariableService
            .save(this.tipoVariable)
            .subscribe((tipoVariable) => {
                this.tipoVariable = tipoVariable;
                //Inicializo variables
                this.tipoVariable = new TipoVariable();
                console.log(this.tipoVariable);
                //Ocultar modal
                $("#modalTipoVariable").modal("hide");
                //Reseteo formtipoVariable para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoVariable/tipoVariable.component.ts